<template>
    <tinymce-editor :id="'editor' + idEditor" :api-key="$tinymceApi" :value="vModelName" @input="$emit('update:vModelName', $event)"
        :plugins="Plugins" :toolbar="Toolbar" :init="Init"></tinymce-editor>
</template>

<script>
    import axios from 'axios';
    import 'jodit/build/jodit.min.css';
    import Editor from '@tinymce/tinymce-vue';

    export default {
        components: {
            'tinymce-editor': Editor,

        },
      props: {
        vModelName: {
          type: String,
          required: true
        },
        media: {
          type: Boolean,
          default: true
        },
        idEditor: {
          type: Number,
          default: undefined
        },
        height: {
          type: Number,
          default: 450
        }
      },

      data: function () {
          let self = this;
          let toolbar = 'formatselect | bold italic strikethrough forecolor backcolor permanentpen | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent | removeformat | addcomment | code | link image media pageembed';

          if (!this.media) {
            toolbar = toolbar.replace(' | link image media pageembed', '');
          }

            return {

                Plugins: ' code print preview fullpage paste searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount spellchecker imagetools textpattern help ',
                Toolbar: toolbar,
                Init: {
                    paste_data_images: true,
                    height: this.height,
                    image_title: true,
                    image_description: false,
                    setup(editor) {
                        editor.on('keydown', function (event) {
                            if (event.key === 'Enter') {
                                if (!event.shiftKey) {

                                // Prevent normal enter behavior (move to next line)
                                event.preventDefault();

                                }

                                // Otherwise, allow Shift+Enter to create a new line
                            }
                            });
                        },
                    init_instance_callback: (editor) => {
                        // Listen for keydown events in the editor
                        editor.on('keydown', (e) => {
                             //Check if the '@' key is pressed
                            //  if (e.key === '@') {
                                //  this.onInput(e);
                                this.$emit('onInput', editor, e);
                                this.$emit('handleKeydown',editor,e);
                                // alert('You pressed the @ key');
                                // }
                             });
                        },

                }
            }
        }
     }
</script>